export const inputStyles = {
    outlined: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
            },
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            "&:hover fieldset": {
                borderColor: "#2162FF",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#2162FF",
                borderWidth: "2px",
            },
            "&.Mui-error fieldset": {
                borderColor: "#d32f2f",
                borderWidth: "2px",
            },
        },
    },

    filled: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
            },
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            "&:hover fieldset": {
                borderColor: "#2162FF",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#2162FF",
                borderWidth: "2px",
            },
            "&.Mui-error fieldset": {
                borderColor: "#d32f2f",
                borderWidth: "2px",
            },
        },
    },

    // Default style - filled background
    default: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
            },
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            "&:hover fieldset": {
                borderColor: "#2162FF",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#2162FF",
                borderWidth: "2px",
            },
            "&.Mui-error fieldset": {
                borderColor: "#d32f2f",
                borderWidth: "2px",
            },
        },
    }
} as const;

export type InputVariant = keyof typeof inputStyles;
